import React from 'react'
import { Chevron } from '../../icons'

import css from './ExpandableBottomCard.styles.scss'

import { ExpandableBottomCardProps } from './ExpandableBottomCard.types'

const ExpandableBottomCard: React.FC<ExpandableBottomCardProps> = ({
  openOnLoad = true,
  summaryContent,
  children,
  onOpen,
  onClose,
}) => {
  const handleToggle = (e: React.SyntheticEvent<HTMLDetailsElement>) => {
    const nativeEvent = e.nativeEvent as any // Couldn't find a type for the toggle event

    if (nativeEvent.newState === 'open' && onOpen) {
      onOpen()
    } else if (nativeEvent.newState === 'closed' && onClose) {
      onClose()
    }
  }

  return (
    <div
      className={css.ExpandableBottomCard}
      data-testid="ExpandableBottomCard"
    >
      <details
        className={css.ExpandableBottomCard__contentWrapper}
        open={openOnLoad}
        onToggle={handleToggle}
      >
        <summary data-testid="ExpandableBottomCard__summary">
          <div
            className={css.ExpandableBottomCard__summaryContent}
            data-testid="ExpandableBottomCard__summaryContent"
          >
            {summaryContent}
          </div>
          <Chevron className={css.ExpandableBottomCard__chevron} />
        </summary>

        {children}
      </details>
    </div>
  )
}

export default ExpandableBottomCard
